import React from 'react';
import './DownloadApp.css';

function DownloadApp() {
  return (
    <section className="app-download" aria-label="Download the Click app">
      <div className="app-download-copy">
        <h2>Take your memories with you</h2>
        <p>Download the Click app to stay connected to your events.</p>
      </div>
      <div className="app-download-links">
        <a href="https://apps.apple.com/app/click" target="_blank" rel="noopener noreferrer" aria-label="Download on the App Store (opens in a new tab)">
          <span>Download on the</span><strong>App Store</strong>
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.canvasandcode.click" target="_blank" rel="noopener noreferrer" aria-label="Get it on Google Play (opens in a new tab)">
          <span>Get it on</span><strong>Google Play</strong>
        </a>
      </div>
    </section>
  );
}

export default DownloadApp;
